export const getToken = () => {
    return localStorage.getItem("authToken");
};

export const getUser = () => {
    try {
        return JSON.parse(localStorage.getItem("user"));
    } catch {
        return null;
    }
};

export const isLoggedIn = () => {
    return !!getToken() && !!getUser();
};

export const getRole = () => {
    const user = getUser();
    return user?.userType; // "Internal" (super admin) | "Client" (org user)
};
